export default "__VITE_ASSET__04903e22__"